module.exports = __webpack_public_path__ + "static/img/12.4852617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/12.png
// module id = 129
// module chunks = 2